
import Dialog from 'quasar/src/plugins/Dialog.js';

import i18n, { paramsSubstituteTranslate, getI18n } from '@/plugins/i18n'
import { useNotify } from './notify'
import { useAuthService } from '@/services/auth.service'
import router, { menuRoutesEnum } from '@/router'

import { usePortalStore } from '@/stores/portal.store'
import { useWebSiteStore } from '@/stores/web-site.store'

const { redirectToAuth, redirectToBaseAuth } = useAuthService()
let tenantMismatchDialog = null

export const useException = () => {
  const portalStore = usePortalStore()

  const processError = async(err) => {
    if (err?.response?.status === 403 && err?.response?.data?.code === 'tenant_mismatch') {
      if (!tenantMismatchDialog) {
        const { t } = i18n.global
        const webSiteStore = useWebSiteStore()

        tenantMismatchDialog = Dialog.create({
          title: t('error.generic_authentication'),
          message: t('error.authentication.tenant_mismatch.message'),
          persistent: true,
          ok: { label: t('common.logout'), color: 'primary' },
        })
        tenantMismatchDialog.onOk(async() => await webSiteStore.logoutAsync())
        tenantMismatchDialog.onDismiss(() => { tenantMismatchDialog = null })
      }
      return
    }

    if (!(err.config?.skipErrorMessage === true || (typeof err.config?.skipErrorMessage === 'function' && err.config.skipErrorMessage(err)))) {
      let message = 'error.generic'
      let params = {}
      let type = 'error'
      const i18n = getI18n()

      if (err) {
        message = err.message || err
      }

      if (err.response && err.response.data) {
        message = err.response.data.message || err.response.data.toString()
        params = err.response.data.params || {}
      }
      const data = err.errorDetails?.details || err.response?.data?.details
      if (data && (data[0]?.errors?.[0]?.code || data[0]?.errors?.[0]?.code)) {
        message = data[0].errors[0].code
        params = data[0].errors[0].params || {}
      }
      // err.httStatus comes from data-grid OdataStore https://js.devexpress.com/Vue/Documentation/ApiReference/Data_Layer/ODataStore/Configuration/#errorHandler
      if (err.httpStatus === 401 || (err.response && err.response.status === 401)) {
        redirectToAuth()
        return
      } else if (err.httpStatus === 403 || (err.response && err.response.status === 403)) {
        redirectToBaseAuth()
        return
      } else if (err.httpStatus === 404 || (err.response && err.response.status === 404)) {
        if (window.config.IS_DEBUG) {
          console.debug(`${err?.response?.statusText} - ${err?.response?.config?.url}`)
          message = i18n.t(err.response?.data?.error || err.response?.data?.message) || i18n.t('error.obsolete_data')
        } else {
          message = 'warning.file_not_found'
          type = 'warning'
        }

        err.config?.onNotFound?.()
      } else if (message.startsWith('error.')) {
        type = 'error'
      } else if (message.startsWith('warning.')) {
        type = 'warning'
      } else {
        message = 'error.generic'
      }

      const { notifyError, notifyWarning } = useNotify()

      if ((err.httpStatus === 400 || err.response?.status === 400) && message === 'error.validation.privacy_check') {
        notifyError(i18n.t('error.validation.privacy_check'), {
          timeout: window.config.NOTIFICATION_DURATION,
          actions: [
            {
              label: i18n.t('common.complete_action'), size: 'sm', color: 'white', handler: async() => {
                const route = { path: menuRoutesEnum.SUBJECTS, query: { code: params['subjectCode'], openEdit: true, subjectValidation: portalStore.subjectValidationTypesEnum.PRIVACY, tab: 1 } }
                const resolvedRoute = router.resolve(route)
                window.open(resolvedRoute.href, '_blank')
              }
            }
          ]
        })
        return
      }

      if (type === 'warning') {
        notifyWarning(paramsSubstituteTranslate(message, params) || message)
      } else {
        notifyError(
          paramsSubstituteTranslate(message, params) || message,
          {
            actions: err.config?.reloadAsync ? [
            {
              icon: 'mdi-refresh',
              color: 'white',
              handler: async() => await err.config.reloadAsync()
            }
            ] : []
          }
        )
      }
    }
  }

  return { processError }
}
